<template>
  <div :class="classes">
       <pt-page-title title="用户详情" ></pt-page-title>
       <pt-page-menu-filter :tabs="pageTopMenuFilter" v-model="detailTab" @select="changedTab"></pt-page-menu-filter>
       <div v-loading="loading">
           <customer-detail-message @unbindWx="unbindWx" @registryCps="registryCps" :wxDetail="wxDetail" :userDetail="userDetail" v-if="isBasic" :shippingAddresses="shippingAddresses" :levelDetail="levelDetail"></customer-detail-message>
           <life-bank-order-message v-if="isOrder"  :id="id" :tableLabels="historyOrderLabels"></life-bank-order-message>
           <health-record-message v-if="isHealthRecord" :id="id" :tableLabels="healthRecordLabels"></health-record-message>
           <life-bank-milestone-message v-if="isMilestone" :id="id" :tableLabels="milestoneLabels"></life-bank-milestone-message>
           <invited-customer v-if="isUserOfInvite&&userDetail.userLogin" :id="id" @getCustomerDetail="getCustomerDetail" :userLogin="userDetail.userLogin"></invited-customer>
           <wallet-message v-if="isWallet" :id="id"></wallet-message>
           <customer-coupons v-if="isCoupon" :userId="id" @mallUserDetail="mallUserDetail" @getCouponDetail="getCouponDetail"></customer-coupons>
           <life-bank-sample v-if="isSample" :id="id" :tableLabels="lifeBankSampleTableLabels"></life-bank-sample>
           <operate-order v-if="isOperate&&userDetail.userLogin" :id="id" :tableLabels="operateOrderTableLables" :userLogin="userDetail.userLogin"></operate-order>
           <exchange-record v-if="isExchange&&userDetail.userLogin" :tableLabels="exchangeRecordLabels" :userLogin="userDetail.userLogin" :id="userDetail.id"></exchange-record>
           <integral-record v-if="isIntegral&&userDetail.userLogin" :tableLabels="integralRecordLabels" :filterLabels="integralFilterLabels" :userLogin="userDetail.userLogin"></integral-record>
					 <invoice-list v-if="isInvoice&&userDetail.userLogin" :userLogin="userDetail.userLogin"></invoice-list>
       </div>
  </div>
</template>

<script>
// 组件class前缀
import { pageTopMenuFilter, historyOrderLabels, healthRecordLabels, exchangeRecordLabels, integralRecordLabels, integralFilterLabels, milestoneLabels, lifeBankSampleTableLabels, operateOrderTableLables } from './customer-detail-option'
import customerDetailMessage from './customer-detail-message'
import lifeBankOrderMessage from './life-bank-order-message'
import healthRecordMessage from './health-record-message'
import lifeBankMilestoneMessage from './life-bank-milestone-message'
import invitedCustomer from './invited-customer'
import walletMessage from './wallet-message'
import customerCoupons from './customer-coupons'
import lifeBankSample from './life-bank-sample'
import operateOrder from './operate-order'
import exchangeRecord from './exchange-record'
import integralRecord from './integral-record'
import invoiceList from "./invoice-list.vue"
const prefixCls = 'pt-customer-detail'
export default {
  name: 'pt-customer-detail',
  components: {
    customerDetailMessage,
    lifeBankOrderMessage,
    healthRecordMessage,
    lifeBankMilestoneMessage,
    invitedCustomer,
    walletMessage,
    customerCoupons,
    lifeBankSample,
    operateOrder,
    exchangeRecord,
    integralRecord,
		invoiceList
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    isBasic () {
      return this.detailTab === 'basic-message'
    },
    isOrder () {
      return this.detailTab === 'lifeBank-order'
    },
    isMilestone () {
      return this.detailTab === 'lifeBank-milestone'
    },
    isHealthRecord () {
      return this.detailTab === 'health-record'
    },
    isUserOfInvite () {
      return this.detailTab === 'user-of-invite'
    },
    isWallet () {
      return this.detailTab === 'wallet'
    },
    isCoupon () {
      return this.detailTab === 'coupon'
    },
    isSample () {
      return this.detailTab === 'lifeBank-sample'
    },
    isOperate () {
      return this.detailTab === 'operate-order'
    },
    isExchange () {
      return this.detailTab === 'exchange-record'
    },
    isIntegral () {
      return this.detailTab === 'integral-record'
    },
		isInvoice(){
			return this.detailTab === 'invoice'
		}
  },
  props: {
    userDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    wxDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    shippingAddresses: {
      type: Array,
      default: function () {
        return []
      }
    },
    levelDetail: {
      type: Object,
      efault: function () {
        return {}
      }
    }
  },
  watch: {
    $route (val) {
      this.detailTab = (val.query && val.query.state) || 'basic-message'
    }
  },
  data () {
    return {
      pageTopMenuFilter: pageTopMenuFilter,
      detailTab: 'basic-message',
      historyOrderLabels: historyOrderLabels,
      healthRecordLabels: healthRecordLabels,
      integralRecordLabels: integralRecordLabels,
      integralFilterLabels: integralFilterLabels,
      exchangeRecordLabels: exchangeRecordLabels,
      milestoneLabels: milestoneLabels,
      lifeBankSampleTableLabels: lifeBankSampleTableLabels,
      operateOrderTableLables: operateOrderTableLables
    }
  },
  methods: {
    mallUserDetail () {
      this.$emit('mallUserDetail')
    },
    getCustomerDetail (id) {
      this.$router.push('/all-customer/customer-detail/' + id + '?state=basic-message')
      this.detailTab = 'basic-message'
    },
    getCouponDetail (id) {
      this.$router.push('/promotion-coupon/coupon-detail/' + id)
    },
    changedTab () {
      if (this.isBasic) {
        this.$emit('userTabPage')
      } else if (this.isLifeBank) {
      }
    },
    unbindWx (val) {
      this.$emit('unbindWx', val)
    },
    registryCps () {
      this.$emit('registryCps')
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
